// @flow

/**
 * Ids of categories
 * @type {Object}
 * @private
 */
export const CATEGORY_IDS = {
  REQUEST: 'request',
  COMFORT: 'comfort',
}

/**
 * Ids of amenities
 * @type {Object}
 * @private
 */
export const AMENITY_IDS = {
  WIFI: 'wifi',
  WHEELCHAIR: 'wheelchair',
  RIDE_TRACKING: 'rideTracking',
  AIRPORT_KIOS: 'airportKiosk',
  BABY_SEATS: 'babySeats',
  PETS: 'pets',
  MEET_AND_GREET: 'meetAndGreet',
  ENGLISH: 'english',
  BULLET_PROOF: 'bulletProof',
  RECOMMENDED: 'recommended',
}

/**
 * Categories of amenities
 * @type {Object}
 * @private
 */
export const categories = {
  [CATEGORY_IDS.REQUEST]: 'Request',
  [CATEGORY_IDS.COMFORT]: 'Comfort',
}

/**
 * Amenities supported
 * @type {Array}
 * @private
 */
const amenities = [
  {
    id: AMENITY_IDS.WIFI,
    name: 'WiFi',
    category: CATEGORY_IDS.REQUEST,
  },
  {
    id: AMENITY_IDS.WHEELCHAIR,
    name: 'Wheelchair accessible',
    category: CATEGORY_IDS.REQUEST,
  },
  {
    id: AMENITY_IDS.RIDE_TRACKING,
    name: 'Ride tracking',
    category: CATEGORY_IDS.REQUEST,
  },
  {
    id: AMENITY_IDS.AIRPORT_KIOS,
    name: 'Airport Kiosk',
    category: CATEGORY_IDS.REQUEST,
  },
  {
    id: AMENITY_IDS.BABY_SEATS,
    name: 'Baby seats',
    category: CATEGORY_IDS.COMFORT,
  },
  {
    id: AMENITY_IDS.PETS,
    name: 'pets',
    category: CATEGORY_IDS.COMFORT,
  },
  {
    id: AMENITY_IDS.MEET_AND_GREET,
    name: 'Meet & Greet',
    category: CATEGORY_IDS.COMFORT,
  },
  {
    id: AMENITY_IDS.ENGLISH,
    name: 'English speaker driver',
    category: CATEGORY_IDS.COMFORT,
  },
  {
    id: AMENITY_IDS.BULLET_PROOF,
    name: 'Bulletproof cars',
    category: CATEGORY_IDS.COMFORT,
  },
]

export default amenities
